import { c as _c } from "react/compiler-runtime";
import { CircularProgress as MuiCircularProgress } from '@mui/material';
import { styled, SxProps, Theme } from '@classify/react-core-components/styles';
import percentService from './services/percent';
export interface Props {
  maxValue: number;
  value: number;
  sx?: SxProps<Theme>;
}
const Root = styled('div')({
  position: 'relative',
  display: 'inline-block',
  height: 20,
  width: 20
});
const Circle = styled(MuiCircularProgress)(({
  theme: {
    palette
  }
}) => ({
  color: palette.divider,
  position: 'absolute',
  border: 'none'
}));
const Progress = styled(MuiCircularProgress)(({
  theme: {
    palette
  }
}) => ({
  color: palette.progress.learningAsset.inProgress,
  strokeLinecap: 'round',
  position: 'relative'
}));
const MIN_DISPLAYABLE_VALUE = 1;
const MAX_DISPLAYABLE_VALUE = 94;
function CircularLearningProgress(t0) {
  const $ = _c(14);
  const {
    value,
    maxValue,
    sx: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const sx = t2;
  let t3;
  if ($[2] !== maxValue || $[3] !== value) {
    t3 = percentService.getPercent(value, maxValue);
    $[2] = maxValue;
    $[3] = value;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const percent = Math.min(Math.max(t3, MIN_DISPLAYABLE_VALUE), MAX_DISPLAYABLE_VALUE);
  let t4;
  if ($[5] !== percent) {
    t4 = percent === MAX_DISPLAYABLE_VALUE ? {
      style: {
        transform: "rotate(-80deg)"
      }
    } : {};
    $[5] = percent;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const progressProps = t4;
  if (value === maxValue) {
    return null;
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Circle variant="determinate" value={100} size={20} thickness={6} />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== percent || $[9] !== progressProps) {
    t6 = <Progress variant="determinate" value={percent} size={20} thickness={6} {...progressProps} />;
    $[8] = percent;
    $[9] = progressProps;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== sx || $[12] !== t6) {
    t7 = <Root aria-hidden={true} sx={sx}>{t5}{t6}</Root>;
    $[11] = sx;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}
export default CircularLearningProgress;